import BaseControl from "./base_control";

export default class GpxDownloadControl extends BaseControl {
  constructor({
    axios,
    onGpxUrlRetrieved,
    onGpxUrlNotRetrieved = () => {},
    routeId,
    options = {}
  }) {
    super(options);

    this._axios = axios;
    this._endpoint = `/api/routes/${routeId}/gpx_url`;
    this._onGpxUrlRetrieved = onGpxUrlRetrieved;
    this._onGpxUrlNotRetrieved = onGpxUrlNotRetrieved;
    this._className = options.className;
    this._title = options.title || "Download course as a GPX file";
    this._innerHTML = '<i class="fas fa-lg fa-file-download"/>';
  }

  async _eventHandler(_event) {
    try {
      const response = await this._axios.get(this._endpoint);
      const gpx_url = response.data["gpx_url"];
      this._onGpxUrlRetrieved(gpx_url);
    } catch(error) {
      this._onGpxUrlNotRetrieved(error);
    }
  }
}
